import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface CardTagHeaderProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Right-aligned tag container for OHS Hub listing cards.
 * Positions the tag in the top-right of the card content area.
 * The 12px inset from card edges is provided by the card's own padding (pt-3 px-3),
 * so no additional margin is needed here.
 */
export const CardTagHeader: React.FC<CardTagHeaderProps> = ({ children, className }) => (
  <div className={twMerge('flex items-start self-end', className)}>{children}</div>
);
